import Highcharts from "highcharts";
import HighchartsReact, { HighchartsReactRefObject } from "highcharts-react-official";
import { RefObject } from "react";

interface PaxChartProps {
  readonly options: Highcharts.Options;
  chartRef?: RefObject<HighchartsReactRefObject>;
}

export function PaxChart({ options, chartRef }: PaxChartProps) {
  return <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />;
}
